// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2DK9j","modalForm":"UpgradeEpcsModal_modalForm___1e1e","modalFooter":"UpgradeEpcsModal_modalFooter__1bZvM"};